import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import AttributionForm from "core/AttributionForm";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import Flexbox from "core/Flexbox";
import AnimationContainer from "icons/AttributionBacklink/AnimationContainer";

import colors from "core/colors";

import { IconButton, InfoIcon, Link, InfoIconTooltip } from "./styles";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";

import { ccbyLicenseLink } from "./data";

const TooltipMessage = () => (
    <>
        Attributing the creator is required per{" "}
        <a href={ccbyLicenseLink} target="_blank">
            CCBY license
        </a>
        . For print, product, and more usage information,{" "}
        <a
            href="https://thenounproject.zendesk.com/hc/en-us/articles/200509948-Medium-Specific-Credit-Requirements-Examples"
            target="_blank"
        >
            see FAQ
        </a>
        .
    </>
);

let AttributionAreaBasicDesktop = ({ className }) => {
    const {
        downloadCount,
        attributionCopied,
        startThankYouAnimation
    } = useAttributionBacklink();

    useEffect(() => {
        if (attributionCopied) {
            startThankYouAnimation();
        }
    }, [attributionCopied]);

    if (!downloadCount) return null;

    return (
        <AnimationContainer className={className}>
            <Flexbox alignItems="center">
                <Heading headingColor={colors.primary.diamond} size="xs">
                    You must attribute the artist
                </Heading>
                <InfoIconTooltip message={<TooltipMessage />} clickToOpen>
                    <IconButton>
                        <InfoIcon />
                    </IconButton>
                </InfoIconTooltip>
            </Flexbox>
            <BodyText type="p" copyColor={colors.primary.diamond} size="lg">
                Insert the link below for digital uses.{" "}
                <Link
                    href="https://thenounproject.zendesk.com/hc/en-us/sections/200137528-Icon-Credit-Requirements"
                    target="_blank"
                >
                    More info
                </Link>
            </BodyText>
            <AttributionForm onDesktop />
        </AnimationContainer>
    );
};

AttributionAreaBasicDesktop.propTypes = {
    className: PropTypes.string
};

AttributionAreaBasicDesktop = styled(AttributionAreaBasicDesktop)``;

export default AttributionAreaBasicDesktop;
